module.exports = __webpack_public_path__ + "img/gift_tr.96d72b30.jpg";